module.exports = __webpack_public_path__ + "96d5b7d95ae99ecc89a6497f0108044b.svg";